export enum PERMISSIONS {
  ACCOUNT_DELETE_GRANTED = "account-delete-granted",
  SABRE_EPR_GRANTED = "sabre-epr-granted",
  IT_PROGRAM_GRANTED = "it-program-granted",
  REPAIR_TOOL_GRANTED = "repair-tool-granted",
  DEMAND_FOR_SUPPLIES = "demand-for-supplies",

  BUSINESS_TICKETS = "business-tickets",
  SECURITY_CONTROL_CARD = "security-control-card",
  SECURITY_CARDS_EXTERNAL = "security-cards-external",
  BUSINESS_VEHICLE_CARD = "business-vehicle-card",
  EXTERNAL_BUSINESS_VEHICLE_CARD = "ex-business-vehicle-card",
  BUSINESS_VEHICLE = "business-vehicle",

  ABSENCE_LETTER = "absence-letter",
  NO_SALARY_LEAVE_TSN = "no-salary-leave-tsn",
  SUSPEND_CONTRACT_TSN = "suspend-contract-tsn",
  TERMINATION_CONTRACT_TSN = "termination-contract-tsn",

  ABSENCE_LETTER_NBA = "absence-letter-nba",

  ABSENCE_LETTER_DAD = "absence-letter-dad",
  MATERNITY_LEAVE_DAD = "maternity-leave-dad",
  SICK_LEAVE_DAD = "sick-leave-dad",
  NO_SALARY_LEAVE_DAD = "no-salary-leave-dad",
  SUSPEND_CONTRACT_DAD = "suspend-contract-dad",
  TERMINATION_CONTRACT_DAD = "termination-contract-dad",

  CONFIG_PERM_USERS = "config-perm-users",
  CONFIG_PERM_APPROVERS = "config-perm-approvers",
  CONFIG_PERM_AFLS = "config-perm-afls",
}
